import React, {useCallback, useEffect, useState} from 'react';
import close from "../../../../images/close.svg";
import arrow from "../../../../images/down.svg";
import {useTheme} from "../../../../App";
import {userApi} from "../../../../redux/user/user-api";
import {fromDateToStringDate} from "../../../../utils";
import {useTranslation} from "react-i18next";
import {getCurrentCrewFile, getTripInvitations} from "../../../../redux/logbook/logbook-thunks";
import {connect} from "react-redux";
import TeamMember from "./TeamMember";

const TripInfo = ({closeModal, logItem, tripInvitations, getTripInvitations, getCurrentCrewFile, currentCrewFile}) => {
  const {isDark} = useTheme()
  const {t} = useTranslation()
  const [crewFileName, setCrewFileName] = useState(null)
  const fetchFileInfo = useCallback(async (id) => {
    const response = await userApi.getFileInfo(id)
    setCrewFileName(response.data.filename)
  }, [])
  useEffect(() => {
    if (logItem.crew_list_file_link) {
      fetchFileInfo(logItem.crew_list_file_link)
    }
  }, [])
  console.log(logItem)
  return (
    <div className={`modal w-700 ${isDark && 'modal__dark'} ${currentCrewFile && 'hidden-block'}`}>
      <h5 className="modal__mainTitle mr-30">{t('tripDetails')}</h5>
      <button onClick={closeModal} className="modal__close">
        <img src={close} alt=""/>
      </button>
      <div className={'modal__sections'}>
        <div className="modal__section">
          <input defaultChecked={true} id={'check'} type="checkbox" className={'modal__check'}/>
          <label htmlFor={'check'} className="modal__subTitle">
            <h6 className="modal__underTitle">{t('tripDetails')}</h6>
            <div className="modal__collapse">
              <img src={arrow} alt=""/>
            </div>
          </label>
          <div className="modal__inputs">
            <div className="modal__values">
              <div className="modal__valueItem">
                <p className="modal__key">{t('dateStartAndFinish')}:</p>
                <p
                  className="modal__value">{fromDateToStringDate(logItem.start_date)} - {fromDateToStringDate(logItem.finish_date)}</p>
              </div>
              <div className="modal__valueItem">
                <p className="modal__key">{t('days')}:</p>
                <p
                  className="modal__value">{logItem.days !== 0 ? logItem.days : (new Date(logItem.finish_date) - new Date(logItem.start_date)) / (24 * 3600 * 1000)}</p>
              </div>
              <div className="modal__valueItem">
                <p className="modal__key">{t('role')}:</p>
                <p className="modal__value">{logItem.role.name}</p>
              </div>
              {logItem.miles !== 0 && <div className="modal__valueItem">
                <p className="modal__key">{t('milesTraveled')}:</p>
                <p className="modal__value">{logItem.miles}</p>
              </div>}
              {logItem.tidal !== undefined && <div className="modal__valueItem">
                <p className="modal__key">{t('tidalRegion')}:</p>
                <p className="modal__value">{logItem.tidal ? t('yes') : t('no')}</p>
              </div>}
              {logItem.night_hours !== 0 && <div className="modal__valueItem">
                <p className="modal__key">{t('nightHours')}:</p>
                <p className="modal__value">{logItem.night_hours}</p>
              </div>}
            </div>
          </div>
        </div>
        <div className="modal__section">
          <input defaultChecked={true} id={'check2'} type="checkbox" className={'modal__check'}/>
          <label htmlFor={'check2'} className="modal__subTitle">
            <h6 className="modal__underTitle">{t('yacht')}</h6>
            <div className="modal__collapse">
              <img src={arrow} alt=""/>
            </div>
          </label>
          <div className="modal__inputs">
            <div className="modal__values">
              {logItem.yacht_model && <div className="modal__valueItem">
                <p className="modal__key">{t('model')}:</p>
                <p className="modal__value">{logItem.yacht_model.name}</p>
              </div>}
              {logItem.yacht && <div className="modal__valueItem">
                <p className="modal__key">{t('yachtName')}:</p>
                <p className="modal__value">{logItem.yacht.name}</p>
              </div>}
              {logItem.operator && <div className="modal__valueItem">
                <p className="modal__key">{t('operator')}:</p>
                <p className="modal__value">{logItem.operator?.name}</p>
              </div>}
              {logItem.yacht?.yacht_owner_name && <div className="modal__valueItem">
                <p className="modal__key">{t('yachtOwner')}:</p>
                <p className="modal__value">{logItem.yacht?.yacht_owner_name}</p>
              </div>}
              {logItem.yacht?.year && <div className="modal__valueItem">
                <p className="modal__key">{t('year')}:</p>
                <p className="modal__value">{logItem.yacht.year}</p>
              </div>}
              <div className="modal__valueItem"/>
            </div>
          </div>
        </div>
        <div className="modal__section">
          <input defaultChecked={true} id={'check3'} type="checkbox" className={'modal__check'}/>
          <label htmlFor={'check3'} className="modal__subTitle">
            <h6 className="modal__underTitle">{t('sailRegion')}</h6>
            <div className="modal__collapse">
              <img src={arrow} alt=""/>
            </div>
          </label>
          <div className="modal__inputs">
            <div className="modal__values">
              {logItem.start_country?.name && <div className="modal__valueItem">
                <p className="modal__key">{t('marinaStart')}:</p>
                <p className="modal__value">
                  {`${logItem.start_marina?.name ? `${logItem.start_marina?.name}, ` : ''} ${logItem.start_country?.name}`}
                </p>
              </div>}
              {logItem.finish_country?.name && <div className="modal__valueItem">
                <p className="modal__key">{t('marinaFinish')}:</p>
                <p className="modal__value">
                  {`${logItem.finish_marina?.name ? `${logItem.finish_marina?.name}, ` : ''} ${logItem.finish_country?.name}`}
                </p>
              </div>}
              {logItem.itinerary && <div className="modal__valueItem w-100">
                <p className="modal__key">{t('route')}:</p>
                <p className="modal__value">{logItem.itinerary}</p>
              </div>}
            </div>
          </div>
        </div>
        {(logItem.description || crewFileName) && <div className="modal__section">
          <input defaultChecked={true} id={'check4'} type="checkbox" className={'modal__check'}/>
          <label htmlFor={'check4'} className="modal__subTitle">
            <h6 className="modal__underTitle">{t('description')}</h6>
            <div className="modal__collapse">
              <img src={arrow} alt=""/>
            </div>
          </label>
          <div className="modal__inputs">
            <div className="modal__values">
              {logItem.description && <div className="modal__valueItem">
                <p className="modal__value">{logItem.description}</p>
              </div>}
              {crewFileName && <div className="modal__valueItem">
                <p className="modal__key">{t('crewList')}:</p>
                <p onClick={() => getCurrentCrewFile(logItem.crew_list_file_link)} className="modal__image">{crewFileName}</p>
              </div>}
            </div>
          </div>
        </div>}
        <div className="modal__section">
          <input defaultChecked={true} id={'check5'} type="checkbox" className={'modal__check'}/>
          <label htmlFor={'check5'} className="modal__subTitle">
            <h6 className="modal__underTitle">{t('tripTeam')}</h6>
            <div className="modal__collapse">
              <img src={arrow} alt=""/>
            </div>
          </label>
          <div className="modal__inputs">
            {logItem.team?.map?.((item, index) => <TeamMember key={index} user={item} isHideCheck={true} />)}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  tripInvitations: state.logbookReducer.tripInvitations,
  currentCrewFile: state.logbookReducer.currentCrewFile
})

export default connect(mapStateToProps, {getTripInvitations, getCurrentCrewFile})(React.memo(TripInfo))
